import ApiService from '@/services/core/api.service'

const CropService = {
  async get (query) {
    return ApiService.get(`admin/crops?${query}`)
  },

  async post (payload) {
    return ApiService.post('admin/crops', payload)
  },

  async put (payload) {
    return ApiService.put(`admin/crops/${payload.id}`, payload)
  }
}

export default CropService
